import { jsonldImage } from './JsonldStore';

export const updateJsonldImage = (value) => jsonldImage.update((oldValue) => value);
